import { Component, Inject, Input } from '@angular/core';
import { L10N_LOCALE, L10nLocale, L10nTranslationService } from 'angular-l10n';
import { AlertSettings, FeatureLayerSettings, MunicipalCity } from 'src/app/hickory-api';

@Component({
  selector: 'app-recipient-details-cities',
  templateUrl: './recipient-details-cities.component.html',
  styleUrls: ['./recipient-details-cities.component.scss'],
  standalone: false
})
export class RecipientDetailsCitiesComponent {
  @Input() alert: AlertSettings;

  constructor(
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private translation: L10nTranslationService,
  ) { }

  onCityClick(_item: MunicipalCity) {
    // no-op
  }

  getLayerRecipientCount(layer: FeatureLayerSettings): string {
    const count = layer.Count ?? 0;
    return count > 0 ? "" + count : this.translation.translate('None');
  }
}
